import { LEAK_FEED } from "@/mocks/home";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const RULES = [
  { icon: "ri-eye-line", text: "爆料多为一面之词，建议先回到原帖看完整时间线。" },
  { icon: "ri-archive-drawer-line", text: "标「速递」仅表示即时收录，不代表编辑部已核实。" },
  { icon: "ri-chat-check-line", text: "看到反转别急着站队，瓜往往越滚越大、后文更精彩。" },
];

export default function Leak() {
  return (
    <section id="leak" className="w-full bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <Reveal>
              <SectionHead
                index="03"
                kicker="Breaking"
                title="论坛爆料速递"
                desc="论坛里刚刚长出来的新鲜瓜，按时间滚动。点开即达讨论现场，不错过任何论坛风云。"
                action="查看更多爆料"
              />
            </Reveal>

            <div className="mt-7 flex flex-col">
              {LEAK_FEED.map((item, i) => (
                <Reveal key={item.id} delay={i * 40}>
                  <div className="flex gap-4">
                    <div className="flex flex-col items-center">
                      <div className="mt-1 flex h-2.5 w-2.5 shrink-0 rounded-full bg-accent-500 ring-4 ring-accent-100" />
                      <div className={`w-px flex-1 bg-background-300 ${i === LEAK_FEED.length - 1 ? "hidden" : ""}`} />
                    </div>
                    <article className="group flex-1 cursor-pointer pb-6">
                      <div className="flex flex-wrap items-center gap-2.5">
                        <span className="text-xs font-bold tabular-nums text-foreground-500">{item.time}</span>
                        <span className="rounded-full bg-accent-50 px-2.5 py-0.5 text-[11px] font-bold text-accent-700">
                          {item.source}
                        </span>
                      </div>
                      <p className="mt-2 rounded-md bg-background-50 p-4 text-sm leading-relaxed text-foreground-800 transition-colors group-hover:bg-background-200/50">
                        {item.title}
                      </p>
                    </article>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <Reveal delay={100}>
              <aside className="rounded-lg bg-primary-500 p-6 text-background-50 md:mt-16">
                <div className="flex items-center gap-2 text-xs font-black uppercase tracking-[0.16em] text-accent-100">
                  <i className="ri-shield-check-line" />
                  吃瓜守则
                </div>
                <h3 className="editorial-title mt-3 text-xl font-black leading-snug">
                  有图未必有真相，
                  <br />
                  反转常在半小时后
                </h3>
                <div className="mt-5 flex flex-col gap-4">
                  {RULES.map((r) => (
                    <div key={r.icon} className="flex gap-3">
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-50/15 text-accent-100">
                        <i className={`${r.icon} text-base`} />
                      </span>
                      <p className="text-sm leading-relaxed text-background-100/95">{r.text}</p>
                    </div>
                  ))}
                </div>
                <a
                  href="#hot"
                  className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
                >
                  去围观热帖反转
                  <i className="ri-arrow-right-line" />
                </a>
              </aside>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}